import { ShieldCheck, Users, Sprout } from "lucide-react";
import { Reveal } from "./Reveal";
import { TRUST } from "../../data/content";

const ICONS = [ShieldCheck, Users, Sprout];

export default function Trust() {
  return (
    <section data-testid="trust-section" className="bg-ov-bone py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="font-body text-xs uppercase tracking-[0.2em] font-semibold text-ov-green mb-4">
            Why it matters
          </p>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-px bg-ov-navy/10 border border-ov-navy/10">
          {TRUST.map((t, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={t.title} delay={i * 0.1} className="bg-ov-bone">
                <div className="group h-full p-10 bg-white hover:bg-ov-greenPale transition-colors duration-300">
                  <Icon className="text-ov-green mb-8" size={32} strokeWidth={1.5} />
                  <h3 className="font-display text-3xl text-ov-navy leading-tight">
                    {t.title}
                    <span className="block text-ov-green/80 text-xl italic">{t.sub}</span>
                  </h3>
                  <p className="font-body text-ov-charcoal/70 mt-5 leading-relaxed">{t.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
